// 2_components/header.js
// Header behaviors: moves phone/login into the header-top, builds the mobile
// hamburger menu, copies footer links into the header menu, tracks header height,
// hides the sticky header on scroll-down, and adds a mobile search toggle.

let initializedHamburgerMenu = false;

export function init() {
	const topNavigationBar = document.querySelector(".top-navigation-bar");
	if (topNavigationBar) {
		const headerTop = document.querySelector(".header-top");
		if (headerTop) {
			const projectPhone = topNavigationBar.querySelector(".project-phone");
			if (projectPhone) {
				headerTop.appendChild(projectPhone);

				const contactHours = document.createElement("span");
				contactHours.classList.add("opening-hours");
				contactHours.textContent = window.NAT.translations("contactHours");
				projectPhone.appendChild(contactHours);
			}

			const loginBtn = topNavigationBar.querySelector(".top-nav-button");

			if (loginBtn) {
				headerTop.appendChild(loginBtn);
			}
		}
	}

	closeLoginWidgetOnOutsideClick();

	document.addEventListener("DOMContentLoaded", function () {
		hamburgerMenuLogic();
		copyFooterLinksToHeader();
		detectHeaderHeight();
		stickyHeaderAdjustments();
		addSearchButtonForMobile();
	});

	document.addEventListener("debouncedResize", function () {
		hamburgerMenuLogic();
		detectHeaderHeight();
	});
}

function closeLoginWidgetOnOutsideClick() {
	document.addEventListener("click", function (event) {
		if (!document.body.classList.contains("login-window-visible")) return;
		if (event.target.closest("#login.login-widget")) return;
		if (event.target.closest("[data-target='login']")) return;
		document.body.classList.remove("login-window-visible");
	});
}

function hamburgerMenuLogic() {
	if (initializedHamburgerMenu) return;

	if (!window.NAT.media.isSmallTablet) return;

	const menuHelper = document.querySelector(".menu-helper");
	if (!menuHelper) return;

	initializedHamburgerMenu = true;

	const menuHelperSpan = menuHelper.querySelector(":scope > span");

	menuHelperSpan.addEventListener("click", function () {
		document.body.classList.toggle("has-opened-hamburger-menu");

		if (!document.body.classList.contains("has-opened-hamburger-menu")) {
			closeOpenedExtLi();
			menuHelper.classList.remove("has-opened-menu-level-1");
		}
	});

	const allExt = menuHelper.querySelectorAll("li.ext");
	if (allExt.length > 0) {
		allExt.forEach(function (extLi) {
			const showMoreExtLiSpan = document.createElement("span");
			showMoreExtLiSpan.classList.add("show-more-ext-li");
			extLi.append(showMoreExtLiSpan);

			showMoreExtLiSpan.addEventListener("click", function (e) {
				e.stopPropagation();

				const isCurrentlyOpen = extLi.classList.contains("opened-ext-li");

				closeOpenedExtLi();
				menuHelper.classList.remove("has-opened-menu-level-1");

				if (!isCurrentlyOpen) {
					extLi.classList.add("opened-ext-li");
					menuHelper.classList.add("has-opened-menu-level-1");
				}
			});

			extLi.addEventListener("click", function (e) {
				if (
					extLi.classList.contains("opened-ext-li") &&
					!e.target.closest(".show-more-ext-li") &&
					!e.target.closest(".menu-level-2")
				) {
					closeOpenedExtLi();
					menuHelper.classList.remove("has-opened-menu-level-1");
				}
			});
		});
	}

	function closeOpenedExtLi() {
		const existingOpenedExtLi = menuHelper.querySelectorAll("li.opened-ext-li");
		if (existingOpenedExtLi.length > 0) {
			existingOpenedExtLi.forEach(function (openedLi) {
				openedLi.classList.remove("opened-ext-li");
			});
		}
	}
}

function detectHeaderHeight() {
	const header = document.querySelector("#header");
	if (!header) return;

	const headerHeight = header.offsetHeight;
	document.body.style.setProperty("--header-height", headerHeight + "px");

	if (document.body.classList.contains("admin-logged")) {
		let adminBarHeight = 0;
		const adminBar = document.querySelector(".admin-bar");
		if (adminBar) {
			adminBarHeight = adminBar.offsetHeight;
		}
		document.body.style.setProperty("--admin-bar-height", adminBarHeight + "px");
	}
}

function copyFooterLinksToHeader() {
	const customerLinks = document.querySelector(".customer-links");
	const aboutUsLinks = document.querySelector(".about-us-links");
	const headerTopMenuLevel1 = document.querySelector("#header .menu-helper .menu-level-1");

	if (headerTopMenuLevel1) {
		if (customerLinks) {
			const customerLinksClone = customerLinks.cloneNode(true);
			customerLinksClone.classList.add("customer-links-clone");
			headerTopMenuLevel1.appendChild(customerLinksClone);
		}
	}
	if (headerTopMenuLevel1) {
		if (aboutUsLinks) {
			const aboutUsLinksClone = aboutUsLinks.cloneNode(true);
			aboutUsLinksClone.classList.add("about-us-links-clone");
			headerTopMenuLevel1.appendChild(aboutUsLinksClone);
		}
	}
}

function stickyHeaderAdjustments() {
	const header = document.querySelector("#header");
	if (!header) return;

	let lastScrollTop = 0;
	const scrollThreshold = header.offsetHeight / 2;
	const scrollDownThreshold = 20;
	const scrollUpThreshold = 20;

	window.addEventListener("scroll", function () {
		const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

		if (currentScrollTop > scrollThreshold) {
			if (currentScrollTop - lastScrollTop >= scrollDownThreshold) {
				document.body.classList.add("sticky-header-hidden");
			} else if (lastScrollTop - currentScrollTop >= scrollUpThreshold) {
				document.body.classList.remove("sticky-header-hidden");
			}
		} else {
			document.body.classList.remove("sticky-header-hidden");
		}

		lastScrollTop = currentScrollTop;
	});
}

function addSearchButtonForMobile() {
	const headerSearch = document.querySelector("#header .search");
	if (!headerSearch) return;

	const headerTop = document.querySelector("#header .header-top");
	if (!headerTop) return;

	const searchButton = document.createElement("div");
	searchButton.classList.add("mobile-search-button");
	headerTop.appendChild(searchButton);
	const queryInput = headerSearch.querySelector("input[type='search']");
	searchButton.addEventListener("click", function () {
		headerSearch.classList.toggle("active-mobile-search");

		if (queryInput) {
			// timeout 10ms to wait for the animation to finish
			setTimeout(() => {
				/* if (document.body.classList.contains("sk")) { */
				if (headerSearch.classList.contains("active-mobile-search")) {
					queryInput.click();
					console.log("-------- Raventic Search Dropdown Opened (from mobile search button) ------");
				}
				/* } */
				queryInput.focus();
			}, 10);
		}

		const searchHeight = headerSearch.offsetHeight;
		document.body.style.setProperty("--mobile-search-height", searchHeight + "px");

		document.body.classList.remove("has-opened-hamburger-menu");
	});

	if (queryInput) {
		document.addEventListener("RAVENTIC SEARCH RESULTS LOADED", function () {
			queryInput.value = "";
		});
	}
}
